import request from '@/router/axios';
//获取全部面板模版
export const searchAllPanelTemplate = () => {
  return request({
    url: '/svolt-ess-boss-service/projectPanel/searchAllPanelTemplate',
    method: 'post'
  })
}
//查询全部模版
export const searchPanelTemplateById = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectPanel/searchPanelTemplateById',
    method: 'post',
    params: data
  })
}
//新增或修改面板模板
export const saveOrUpdatePanelTemplate = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectPanel/saveOrUpdatePanelTemplate',
    method: 'post',
    data: data
  })
}

export default{
  searchAllPanelTemplate,
  searchPanelTemplateById,
  saveOrUpdatePanelTemplate
}



// WEBPACK FOOTER //
// ./src/api/dataPanelConfig.js